module.exports = __webpack_public_path__ + "img/ellipsis-stroke-vertical.ac460b80.svg";